class MyLoansFiltersController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    this.statesToFilter = this.objectStatesFilter.statesToFilter;
    this.loansStates = this.objectStatesFilter.loansStates;
    this.selectedFilterStatus='';
  }

  changeFilterByStatus(state) {
    this.selectedFilterStatus = this.selectedFilterStatus === state ? '' : state;
    this.filterByStatus(this.EventEmitter({ status: this.selectedFilterStatus, filterActive: true }));
  }
  
  getFilterClass(state) {
    return {
      'active': this.selectedFilterStatus === state
    };
  }
}

export default MyLoansFiltersController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansFilters/myLoansFilters.controller.js